import PropTypes from "prop-types";

import { ReactComponent as OverviewIconSvg } from "assets/images/icon_overview.svg";
import { ReactComponent as OverviewIconHoverSvg } from "assets/images/icon_overview_hover.svg";

export const OverviewIcon = ({ hover }) => {
  if (hover) {
    return <OverviewIconHoverSvg width={16} height={16} />;
  }
  return <OverviewIconSvg width={16} height={16} />;
};
OverviewIcon.propTypes = {
  hover: PropTypes.bool.isRequired,
};
